import { render, staticRenderFns } from "./DeleteSalaryYearsDialog.vue?vue&type=template&id=786d9c64&scoped=true"
import script from "./DeleteSalaryYearsDialog.vue?vue&type=script&lang=js"
export * from "./DeleteSalaryYearsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786d9c64",
  null
  
)

export default component.exports